module.exports = __webpack_public_path__ + "img/change_3.62c11395.gif";